import type { CreateAgreementCommandData } from '@festina/life-general-types/life'
import { EmployerAgreementsCreateService } from '@festina/life-general-types/life/services/EmployerAgreementsCreateService'
import { useFestinaMutation } from '@festina-life/authentication'
import { assertNotEmpty } from '@festina-life/core'

import type { EmployerAgreementActionProps } from '../types'

const method =
  EmployerAgreementsCreateService.employerAgreementsCreateServicePostEntity

export const useCreateEmployerAgreementCreateCommand = ({
  tenantId,
}: EmployerAgreementActionProps) =>
  useFestinaMutation({
    component: 'life',
    roles:
      EmployerAgreementsCreateService.employerAgreementsCreateServicePostEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: CreateAgreementCommandData) => {
      assertNotEmpty(arg.employerAgreementId)
      await method({
        xTenantId: tenantId,
        employerAgreementId: arg.employerAgreementId,
        requestBody: arg,
      })
    },
  })
